<!--
 * @Author: zhaohaozhuang
 * @Date: 2024-05-08 15:59:20
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2024-09-20 13:39:19
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
  <div class="container">
    <div class="swiper-container-group">
      <div class="swiper-container" ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide-basic swiper-slide" v-if="versionType == 'UNKNOWN' || versionType == 'NEWBASIC'">
            <div class="adjust-type new-version-title">基础版</div>
          </div>
          <div class="swiper-slide-higher swiper-slide">
            <div class="adjust-type  new-version-title">
              <div>经典版</div>
              <div class="tx">￥3980/年</div>
            </div>
          </div>
          <div class="swiper-slide-flag swiper-slide">
            <div class="adjust-type  new-version-title">
              <div>臻享版</div>
              <div class="tx">￥5980/年</div>
            </div>
          </div>
          <div class="swiper-slide-sport swiper-slide">
            <div class="adjust-type  new-version-title">
              <div>运动版</div>
              <div class="tx">￥7480/年</div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <div class="back-white"></div>
      <div v-if="!isExpanded" class="bg-img">
        <template v-for="(item, index) in imgs[type]">
          <div :key="item">
            <img :src="item" alt="" />
            <div class="expand-wrap" v-if="index === 0">
              <div v-if="!isExpanded" class="expand" @click="clickExpand">展开 <img :src="downIcon" alt="" /></div>
              <div v-else class="expand" @click="clickExpand">收起 <img :src="upIcon" alt="" /></div>
            </div>
          </div>
        </template>
      </div>

      <div v-else class="bg-img">
        <div class="expand not" @click="clickExpand"></div>
        <template v-for="item in expandImgs[type]">
          <img :src="item" alt="" :key="item" />
        </template>
        <div class="expand-wrap">
          <div v-if="!isExpanded" class="expand" @click="clickExpand">展开 <img :src="downIcon" alt="" /></div>
          <div v-else class="expand" @click="clickExpand">收起 <img :src="upIcon" alt="" /></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const NewVersionEnum = ['NEWBASIC', 'LEAD', 'ENJOY', 'NEWSPORT'];
export default {
  name: 'newVision',
  props: ['isNewVersion', 'versionType'],
  data() {
    const t = new Date(new Date().toLocaleDateString()).getTime();
    console.log(123, t);
    return {
      type: 'basic',
      initialSlide: 1,
      isExpanded: false, // 是否展开
      downIcon: 'https://image.xiaomaiketang.com/xm/internal/Y7saA4WSY7.png',
      upIcon: 'https://image.xiaomaiketang.com/xm/internal/pyH22tENAY.png',
      left: 'https://image.xiaomaiketang.com/xm/Xe38ktyQkb.png',
      right: 'https://image.xiaomaiketang.com/xm/ZhPsZQWiYM.png',
      xmversion: null,
      imgs: {
        basic: ['https://image.xiaomaiketang.com/xm/internal/3PYYFTi8zS.png', 'https://image.xiaomaiketang.com/xm/internal/febMb2ABtp.png'],
        higher: ['https://image.xiaomaiketang.com/xm/internal/SypMehDXP3.png', 'https://image.xiaomaiketang.com/xm/internal/4ZpGc3shBb.png'],
        flag: ['https://image.xiaomaiketang.com/xm/internal/rMBXNaatx4.png', 'https://image.xiaomaiketang.com/xm/internal/TR3eHwF7CA.png'],
        sport: ['https://image.xiaomaiketang.com/xm/internal/pZBc8PiAP4.png', 'https://image.xiaomaiketang.com/xm/internal/48xBhh2FrK.png'],
      },
      expandImgs: {
        basic: [
          'https://image.xiaomaiketang.com/xm/internal/3PYYFTi8zS.png',
          'https://image.xiaomaiketang.com/xm/internal/E8R35ShRyY.png',
          `https://image.xiaomaiketang.com/xm/internal/febMb2ABtp.png?t=${t}`,
        ],
        higher: [
          'https://image.xiaomaiketang.com/xm/internal/SypMehDXP3.png',
          'https://image.xiaomaiketang.com/xm/internal/BRf6x72s8d.png',
          `https://image.xiaomaiketang.com/xm/internal/4ZpGc3shBb.png?t=${t}`,
        ],
        flag: [
          'https://image.xiaomaiketang.com/xm/internal/rMBXNaatx4.png',
          'https://image.xiaomaiketang.com/xm/internal/53y2Td72Gn.png',
          `https://image.xiaomaiketang.com/xm/internal/TR3eHwF7CA.png?t=${t}`,
        ],
        sport: [
          'https://image.xiaomaiketang.com/xm/internal/pZBc8PiAP4.png',
          'https://image.xiaomaiketang.com/xm/internal/J5QtK4ZH7A.png',
          `https://image.xiaomaiketang.com/xm/internal/48xBhh2FrK.png?t=${t}`,
        ],
      },
    };
  },
  methods: {
    init() {
      const _this = this;
      var swiper = new Swiper('.swiper-container', {
        slidesPerView: 1.16,
        spaceBetween: 8,
        centeredSlides: true,
        // initialSlide: _this.initialSlide >= 4 ? this.initialSlide - 1 : _this.initialSlide,
        initialSlide: _this.initialSlide,
        on: {
          // 动画结束后更改对应的数据
          slideChangeTransitionEnd: function() {
            const index = this.activeIndex;
            console.log(index, 'index');
            console.log(_this.versionType, 'versionType');
            let newTypes;
            if (_this.versionType == 'UNKNOWN' || _this.versionType == 'NEWBASIC') {
              newTypes = ['basic', 'higher', 'flag', 'sport'];
            } else if (_this.versionType != 'UNKNOWN' && _this.versionType != 'NEWBASIC') {
              newTypes = ['higher', 'flag', 'sport'];
            }
            console.log(newTypes);
            _this.type = newTypes[index];
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    },
    // 通过URL获取当前版本

    clickExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  // 判断机构是4.0还是5.0
  created() {
    if (this.versionType == 'UNKNOWN') {
      this.initialSlide = 0;
    } else {
      if (this.versionType == 'NEWBASIC') {
        this.initialSlide = NewVersionEnum.indexOf(this.versionType);
      } else {
        this.initialSlide = NewVersionEnum.indexOf(this.versionType) - 1;
        this.type = ['higher', 'flag', 'sport'][NewVersionEnum.indexOf(this.versionType) - 1];
      }
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less">
.container {
  height: 100vh;
  overflow: scroll;
  font-family: PingFangSC-Regular, PingFang SC;
  background: #ffffff;
  .swiper-container-group {
    width: 100vw;
    height: 198px;
    padding-top: 34px;
    background: #fff3e1;
  }
  .back-white {
    width: 0;
    height: 0;
    border-top: 36px solid transparent;
    border-left: 50vw solid #ffffff;
    border-right: 50vw solid #ffffff;
    // border: 10px solid red;
    position: relative;
    top: -36px;
    z-index: 999;
  }
  .swiper-slide-basic {
    background-image: url('https://image.xiaomaiketang.com/xm/K7f3ARSWmJ.png');
    background-size: 100% 100%;
    color: #ffffff;
    div {
      font-size: 23px;
      color: #ffffff;
    }
  }
  .swiper-slide-higher {
    background-image: url('https://image.xiaomaiketang.com/xm/FiwQTTcrd2.png');
    background-size: 100% 100%;
    color: #333333;
    div {
      font-size: 23px;
      color: #333333;
    }
  }
  .swiper-slide-flag {
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/T8bk8xrGDp.png');
    background-size: 100% 100%;
    color: #ffdba8;
    div {
      font-size: 23px;
      color: #ffdba8;
    }
  }
  .swiper-slide-chain {
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/48rWdPHkeB.png');
    background-size: 100% 100%;
    color: #f7dc86;
  }
  .swiper-slide-sport {
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/internal/cSeYieTC7h.png');
    background-size: 100% 100%;
    color: #ffffff;
    div {
      font-size: 23px;
      color: #ffffff;
    }
  }
  .swiper-slide-aesthetic {
    height: 100%;
    overflow: auto;
    background-image: url('https://image.xiaomaiketang.com/xm/internal/wYzjHdBGi4.png');
    background-size: 100% 100%;
    color: #ffffff;
  }

  .swiper-container {
    height: 195px;
    width: 100vw;
    .swiper-pagination-bullet {
      width: 5px;
      height: 5px;
      &.swiper-pagination-bullet-active {
        background: #fff;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    .adjust-type {
      width: 100%;
      height: 100%;
      font-size: 23px;
      font-weight: 500;
      text-align: center;
      font-weight: 500;
      display: flex;
      flex-direction: column;
      .tx {
        margin-top: 12px;
      }
    }
    .new-version-title {
      width: 100%;
      height: 100%;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      //  font-size: .46rem !important;
    }
    .adjust-money {
      width: 250px;
      height: 21px;
      font-size: 17px;
      margin: auto;
      margin-top: 22px;
      font-weight: 500;
      line-height: 21px;
    }
    .adjust-money-number {
      font-size: 35px;
      font-weight: bold;
    }
    .adjusts-money {
      width: 250px;
      height: 21px;
      font-size: 17px;
      margin: auto;
      margin-top: 42px;
      font-weight: 500;
      line-height: 21px;
    }
  }
  .adjust-service-group {
    height: calc(~'100vh - 160px'); /* 计算除了轮播图的其他内容的高度 */
    .card-content {
      text-align: center;
      width: 328px;
      height: 36px;
      margin: auto;
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      padding: 55px 15px 30px 15px;
      background: #ffffff;
    }
    .adjust-service-title {
      &.basic-function {
        margin-bottom: 13px;
      }
      &.branch-tasting,
      &.study-inline,
      &.add-value {
        margin-bottom: 8px;
      }
      span {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 21px;
        margin: 0 8px;
        vertical-align: middle;
      }
      img {
        width: 12px;
        height: 8px;
      }
    }
  }
  .bg-img {
    position: relative;
    font-size: 0;
    img {
      width: 100%;
    }

    .expand-wrap {
      text-align: center;
      margin-top: 0.32rem;
      padding-bottom: 0.48rem;
      .expand {
        display: inline-block;
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #999999;

        img {
          width: 0.28rem;
          line-height: 0.4rem;
          vertical-align: -0.04rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/renew/newVision.vue